import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { API_ENDPOINTS } from "../../../constants/api_endpoints";
import { TResponse, TResponseWithQData } from "../../../types/common";
import { IStaffMember, listStaff, createStaffMember, updateStaffMember, deleteStaffMember } from "./callbacks";

export const useStaffList = (initialParams: any) => {
  const [params, setParams] = useState(initialParams);
  const result = useQuery<TResponseWithQData<IStaffMember[]>, Error>({
    queryKey: [API_ENDPOINTS.STAFF_LIST, params],
    queryFn: () => listStaff(params).then((r) => r.data),
  });
  return { ...result, refetchWithQuery: (p: any) => setParams((prev: any) => ({ ...prev, ...p })) };
};

export const useStaffCreate = (options?: { onSuccess?: (d: IStaffMember) => void; onError?: (e: any) => void }) => {
  const qc = useQueryClient();
  return useMutation<TResponse<IStaffMember>, Error, any>({
    mutationFn: (data) => createStaffMember(data).then((r) => r.data),
    onSuccess: (res) => { qc.invalidateQueries({ queryKey: [API_ENDPOINTS.STAFF_LIST] }); options?.onSuccess?.(res.data as IStaffMember); },
    onError: options?.onError,
  });
};

export const useStaffUpdate = (options?: { onSuccess?: (d: IStaffMember) => void; onError?: (e: any) => void }) => {
  const qc = useQueryClient();
  return useMutation<TResponse<IStaffMember>, Error, any>({
    mutationFn: (data) => updateStaffMember(data).then((r) => r.data),
    onSuccess: (res) => { qc.invalidateQueries({ queryKey: [API_ENDPOINTS.STAFF_LIST] }); options?.onSuccess?.(res.data as IStaffMember); },
    onError: options?.onError,
  });
};

export const useStaffDelete = (options?: { onSuccess?: () => void; onError?: (e: any) => void }) => {
  const qc = useQueryClient();
  return useMutation<TResponse<null>, Error, number>({
    mutationFn: (id) => deleteStaffMember(id).then((r) => r.data),
    onSuccess: () => { qc.invalidateQueries({ queryKey: [API_ENDPOINTS.STAFF_LIST] }); options?.onSuccess?.(); },
    onError: options?.onError,
  });
};
